import * as React from "react";
import { Dropdown, IDropdownOption, Stack, TextField } from '@fluentui/react';
import { phoneValidation, validate } from "../../util/validate";
interface PhoneFieldProps {
    value: string;
    onChange: (value: string) => void;
    tabIndex?: number;
}
var phonevalidation = phoneValidation.phone;
const PhoneField: React.FunctionComponent<PhoneFieldProps> = props =>
{
    const [countryCode, setCountryCode] = React.useState<string>();
    const [phone, setPhone] = React.useState(props.value.replace(/\s/g, ''));
    React.useEffect(() => {
        if(props.value)
        {
            props.value.replace(/\s/g, '').startsWith('+45') ? setCountryCode('+45') : setCountryCode('');
            setPhone(props.value.replace(/\s/g, '').replace('+45',''));
        }
        else
        {
            setCountryCode('+45');
        }
       
    }, [props.value]);
    const countryOptions: IDropdownOption[] = [
        { key: '+45', text: '+45' },
        { key: '', text: 'other' },
    ];

    const handleCountryChange = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            setCountryCode(option.key as string);
        }
    };

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let inputValue = e.target.value;

        setPhone(inputValue);
        props.onChange(`${countryCode}${inputValue}`);
    };

    return (
        <Stack className="phonenumber" horizontal tokens={{ childrenGap: 20 }}>
            <Dropdown
                selectedKey={countryCode}
                onChange={handleCountryChange}
                options={countryOptions}
                styles={{ dropdown: { width: 75, display: 'inline-block', marginRight: 0 } }}
            />
            {countryCode==='+45'?
                <TextField
                    tabIndex={props.tabIndex}
                    key="dkPhone"
                    validateOnLoad={true}
                    onGetErrorMessage={validate(phonevalidation.validation)}
                    title={phonevalidation.placeholder}
                    type={phonevalidation.type}
                    placeholder={phonevalidation.placeholder}
                    onChange={handlePhoneChange}
                    value={phone}
                    styles={{ fieldGroup: { width: 191, marginLeft: 0 } }}
                />
                : 
                <TextField
                    key="otherPhone"
                    tabIndex={props.tabIndex}
                    onGetErrorMessage={validate({ required: true })}
                    title={phonevalidation.placeholder}
                    type={phonevalidation.type}
                    placeholder={phonevalidation.placeholder}
                    value={phone}
                    onChange={handlePhoneChange}
                    styles={{ fieldGroup: { maxWidth: 191, marginLeft: 0 } }}
                />
            }
        </Stack>
    );
};

export default PhoneField;